<div [hidden]="!layer" class="headerinformation">

  <div class="study">
    <label>{{'EXAM_DATE' | translate}}</label>
    <label>{{layer?.study.description}}</label>
    <label>{{layer?.study.dateTime | datetime: 'dd/MM/yyyy HH:mm'}}</label>
  </div>

  <div class="filters">
    <fixed-filters [filters]="layer?.filters"></fixed-filters>
  </div>

  <div class="patient">
    <label>{{layer?.patient.lastName}} {{layer?.patient.firstName}} ({{layer?.patient.sex}})</label>
    <label>{{layer?.patient.birthDate | date: 'dd/MM/yyyy'}}</label>
  </div>

</div>
